import { render, staticRenderFns } from "./ShowLastAgentMessageConfig.vue?vue&type=template&id=e01035de&scoped=true&"
import script from "./ShowLastAgentMessageConfig.vue?vue&type=script&lang=js&"
export * from "./ShowLastAgentMessageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01035de",
  null
  
)

export default component.exports